import { createFileRoute } from '@tanstack/react-router'
import { CompanySection } from '../../../features/settings/company-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/company')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'company'),
  component: CompanySection,
})
